import * as React from 'react';
import { Wait16 } from '@cian/ui-kit';
import { Note } from '../Note';
import {
  EBackground,
  IWarningMessageSchema,
} from '../../../../../shared/repositories/search-offers/v2/types/WarningMessageSchema';
import styles from './PessimizationFlexible.css';

export interface IPessimizationFlexibleProps {
  warningMessage: IWarningMessageSchema;
}

export const PessimizationFlexible = ({ warningMessage }: IPessimizationFlexibleProps) => {
  const { title, text, background, helpInfo } = warningMessage;
  const isStrong = background === EBackground.Red;

  return (
    <Note
      beforeIcon={<Wait16 color={isStrong ? 'error_100' : 'gray_icons_100'} />}
      theme={isStrong ? 'danger' : undefined}
    >
      {title && <div className={styles['title']}>{title}</div>}
      {text && (
        <div>
          {text}
          {helpInfo && (
            <a href={`${helpInfo.helpInfoLink}`} target="_blank">
              {`${helpInfo.helpInfoText}`}
            </a>
          )}
        </div>
      )}
    </Note>
  );
};

PessimizationFlexible.displayName = 'PessimizationFlexible';
